import { memo, PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../../providers/AuthProvider/hooks';
import { APP_WEB_ROUTES } from '../consts/routes';

function RequireAuthRoute({ children }: PropsWithChildren) {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.user) {
    //Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected.
    return <Navigate to={APP_WEB_ROUTES.login} state={{ from: location }} replace />;
  }
  return <>{children}</>;
}

export default memo(RequireAuthRoute);
